// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Comunidad: grupos, calendario (salas, recursos, aprobaciones) e inscripciones.
export default {
  // Comunes del área
  'Nombre@@cosa': 'Name',
  'Inicio@@hora': 'Start',
  'Fin': 'End',
  'Tipo': 'Type',
  'Estado': 'Status',
  'Lugar': 'Location',
  'Descripción': 'Description',
  'Nota': 'Note',
  'Recursos': 'Resources',
  'Sin recursos.': 'No resources.',
  'Aprobar': 'Approve',
  'Rechazar': 'Decline',
  'Cancelada': 'Canceled',
  'Todas': 'All',
  'Sin datos': 'No data',
  '{n} persona': '{n} person',
  '{n} personas': '{n} people',

  // Grupos
  'Abierto (entra directo)': 'Open (join directly)',
  'Con solicitud': 'Request to join',
  'Cerrado': 'Closed',
  'Asistencia': 'Attendance',
  'Tipos de grupo': 'Group types',
  '{n} grupo activo': '{n} active group',
  '{n} grupos activos': '{n} active groups',
  'Nuevo grupo': 'New group',
  'Nombre del grupo': 'Group name',
  'Sin grupos': 'No groups',
  'Grupo': 'Group',
  'Reunión': 'Meeting',
  'Miembros': 'Members',
  'Líder': 'Leader',
  'Privado': 'Private',
  'Editar grupo': 'Edit group',
  'Cuándo se reúne': 'When it meets',
  'Martes 7:30 pm, cada semana': 'Tuesdays at 7:30 pm, weekly',
  'Casa de la familia Pérez, Doral': 'The Perez family home, Doral',
  'Cupo (opcional)': 'Capacity (optional)',
  'Ingreso': 'Enrollment',
  'Aparece en el directorio público de grupos': 'Show in the public group directory',
  'Solo los líderes del grupo pueden ver esta página': 'Only group leaders can see this page',
  '{n}/{cap} miembros': '{n}/{cap} members',
  '{n} miembro': '{n} member',
  '{n} miembros': '{n} members',
  'El grupo se archivará y dejará de aparecer.': 'The group will be archived and will no longer appear.',
  'Solicitudes pendientes ({n})': 'Pending requests ({n})',
  'Miembros ({n})': 'Members ({n})',
  'Quitar líder': 'Remove leader',
  'Hacer líder': 'Make leader',
  '¿Quitar a {name} del grupo?': 'Remove {name} from the group?',
  'Sin miembros': 'No members',
  'Agregar miembro…': 'Add member…',
  'Este grupo no tiene líder.': 'This group has no leader.',
  'Reuniones': 'Meetings',
  '¿Cancelar esta reunión?': 'Cancel this meeting?',
  'Sin reuniones registradas': 'No meetings yet',
  'Nombre (p. ej. Guía de estudio)': 'Name (e.g. Study guide)',
  'Nueva reunión': 'New meeting',
  'Visitante': 'Visitor',
  'Guardar ({n} presentes)': 'Save ({n} present)',
  'Marcar a todos': 'Mark everyone present',
  '{name} (visitante)': '{name} (visitor)',
  'Agregar visitante': 'Add visitor',
  'Asistencia de grupos': 'Group attendance',
  'Promedio de presentes en las reuniones con asistencia registrada.': 'Average attendance at meetings where attendance was recorded.',
  'Reuniones registradas': 'Meetings recorded',
  'Promedio presentes': 'Average present',
  'Nuevo tipo': 'New type',
  'Oculto del directorio': 'Hidden from directory',
  'Editar tipo': 'Edit type',
  'Mostrar sus grupos en el directorio público': 'Show its groups in the public directory',

  // Calendario
  'Pendiente@@reserva': 'Pending',
  'Aprobada@@reserva': 'Approved',
  'Rechazada@@reserva': 'Rejected',
  'Aprobaciones': 'Approvals',
  'Salas y recursos': 'Rooms & resources',
  'Eventos de la iglesia y reservas de salas y recursos.': 'Church events and room and resource bookings.',
  'Nuevo evento': 'New event',
  'Mes anterior': 'Previous month',
  'Mes siguiente': 'Next month',
  'Hoy': 'Today',
  'Sala': 'Room',
  '+{n} más': '+{n} more',
  'Doble clic en un día para crear un evento. En ámbar: reservas pendientes de aprobación.': 'Double-click a day to create an event. Amber: bookings awaiting approval.',
  'Choca con “{event}” ({status}) el {date}': 'Conflicts with “{event}” ({status}) on {date}',
  '{date}: se piden {requested} y hay {available}': '{date}: {requested} requested, {available} available',
  'Evento': 'Event',
  'El evento se cancelará en todas sus fechas y se liberan sus reservas.': 'The event will be canceled on all its dates and its bookings will be released.',
  'Cancelar evento': 'Cancel event',
  'Reservas pendientes': 'Bookings pending',
  'Reserva rechazada': 'Booking rejected',
  'Cancelado': 'Canceled',
  'Público': 'Public',
  'Toda la organización': 'Entire organization',
  'Todo el día': 'All day',
  '(termina {date})': '(ends {date})',
  'Se repite: {rule}': 'Repeats: {rule}',
  '{n} fecha': '{n} date',
  '{n} fechas': '{n} dates',
  'Reservas': 'Bookings',
  'cada {n} días': 'every {n} days',
  'cada día': 'every day',
  'cada {n} semanas': 'every {n} weeks',
  'cada semana': 'every week',
  'cada {n} meses': 'every {n} months',
  'cada mes': 'every month',
  'hasta {date}': 'until {date}',
  '{n} vez': '{n} time',
  '{n} veces': '{n} times',
  'Guardado. Hay choques de horario: la reserva queda pendiente de revisión.': 'Saved. There are scheduling conflicts, so the booking is pending review.',
  'Guardado. Las reservas esperan aprobación.': 'Saved. The bookings are awaiting approval.',
  'Evento guardado': 'Event saved',
  'Editar evento': 'Edit event',
  'Fecha inicio': 'Start date',
  'Hora inicio': 'Start time',
  'Fecha fin': 'End date',
  'Hora fin': 'End time',
  'Diario': 'Daily',
  'Semanal': 'Weekly',
  'Mensual (mismo día del mes)': 'Monthly (same day of the month)',
  'Cada': 'Every',
  'Intervalo': 'Interval',
  'día(s)': 'day(s)',
  'semana(s) los': 'week(s) on',
  'mes(es)': 'month(s)',
  'Termina': 'Ends',
  'hasta el': 'until',
  'número de veces': 'number of times',
  'Hasta@@fecha': 'Until',
  'Veces': 'Occurrences',
  'Mostrar en el calendario público': 'Show on the public calendar',
  'Salas': 'Rooms',
  'Elige un campus para reservar salas.': 'Choose a campus to book rooms.',
  'requiere aprobación': 'requires approval',
  'Este campus no tiene salas.': 'This campus has no rooms.',
  '(hay {n})': '({n} available)',
  'Cantidad de {name}': 'Quantity of {name}',
  'Reserva aprobada': 'Booking approved',
  'Reservas de salas y recursos que esperan tu decisión.': 'Room and resource bookings awaiting your decision.',
  'No hay reservas pendientes 🎉': 'No pending bookings 🎉',
  'Nota (opcional)': 'Note (optional)',
  'Rechazar@@reserva': 'Reject',
  'Esta reserva choca con otra ya aprobada.': 'This booking conflicts with one that’s already approved.',
  'Aprobar de todos modos': 'Approve anyway',
  'Grupo de aprobación': 'Approval group',
  'Inactiva': 'Inactive',
  'aprueba: {name}': 'approver: {name}',
  'sin aprobación': 'no approval needed',
  'Sin salas': 'No rooms',
  'Nombre (p. ej. Proyector portátil)': 'Name (e.g. Portable projector)',
  'Cantidad@@recurso': 'Quantity',
  'Aprobación': 'Approval',
  'Sin aprobación': 'No approval needed',
  'Grupos de aprobación': 'Approval groups',
  '{n} aprobador': '{n} approver',
  '{n} aprobadores': '{n} approvers',
  'Sin grupos: las reservas se aprueban automáticamente.': 'No groups: bookings are approved automatically.',
  'Editar sala': 'Edit room',
  'Nueva sala': 'New room',
  'Capacidad': 'Capacity',
  'Quién aprueba las reservas': 'Who approves bookings',
  'Nadie (se aprueban solas)': 'No one (approved automatically)',
  'Activa': 'Active',
  'Nuevo grupo de aprobación': 'New approval group',
  'Administración Central': 'Central office',
  'Agregar aprobador': 'Add approver',

  // Inscripciones
  'Borrador': 'Draft',
  'Abierta': 'Open',
  'Cerrada': 'Closed',
  'Archivada': 'Archived',
  'Confirmada': 'Confirmed',
  'Pago pendiente': 'Payment due',
  'Lista de espera': 'Waitlist',
  'Texto': 'Text',
  'Párrafo': 'Paragraph',
  'Lista de opciones': 'Dropdown',
  'Sí/No': 'Yes/No',
  'Número': 'Number',
  'Eventos con cupo, cobro y lista de espera: retiros, campamentos, cursos.': 'Events with capacity limits, payments and waitlists: retreats, camps, classes.',
  'Nueva inscripción': 'New registration',
  'Sin inscripciones': 'No registrations',
  'Inscritos': 'Registered',
  'En espera': 'Waitlisted',
  'Cierra {date}': 'Closes {date}',
  'Editar inscripción': 'Edit registration',
  'Cupo total (opcional)': 'Total capacity (optional)',
  'Abre (opcional)': 'Opens (optional)',
  'Cierra (opcional)': 'Closes (optional)',
  'Visible al público': 'Visible to the public',
  'Lista de espera cuando se llene': 'Waitlist when full',
  'Preguntas por asistente': 'Questions for each attendee',
  'clave': 'key',
  'Clave': 'Key',
  'Pregunta (p. ej. Talla de camiseta)': 'Question (e.g. T-shirt size)',
  'Pregunta': 'Question',
  'Opciones separadas por coma': 'Options, separated by commas',
  'Opciones': 'Options',
  'Obligatoria': 'Required',
  'Página pública': 'Public page',
  'Por cobrar': 'Total due',
  'Cobrado': 'Collected',
  'Saldo {amount}': 'Balance {amount}',
  'Agrega al menos un tipo de inscripción (pestaña Opciones) para que la gente pueda inscribirse.': 'Add at least one registration type (Options tab) so people can register.',
  'Inscritos ({n})': 'Registered ({n})',
  'Opciones y horarios': 'Options and times',
  'Filtro': 'Filter',
  'Activas': 'Active',
  'Canceladas': 'Canceled',
  'espera #{n}': 'waitlist #{n}',
  'Sí': 'Yes',
  'No': 'No',
  'Llegó': 'Checked in',
  'Marcar llegada': 'Check in',
  '{paid} de {total}': '{paid} of {total}',
  'Registrar pago': 'Record payment',
  '¿Cancelar la inscripción de {name}? Si hay lista de espera, entrarán los siguientes.': 'Cancel {name}’s registration? If there’s a waitlist, the next people in line will be moved in.',
  '{n} persona pasó de la lista de espera': '{n} person moved off the waitlist',
  '{n} personas pasaron de la lista de espera': '{n} people moved off the waitlist',
  'Tipos de inscripción': 'Registration types',
  '{count} inscritos': '{count} registered',
  'Gratis': 'Free',
  'Nombre (p. ej. Adulto)': 'Name (e.g. Adult)',
  'Precio': 'Price',
  'Cupo': 'Capacity',
  'Precio inválido': 'Invalid price',
  'Horarios': 'Times',
  'Sin horarios.': 'No times.',
  'Etiqueta (opcional)': 'Label (optional)',
  'Etiqueta': 'Label',
  'Pago de {name}': 'Payment from {name}',
  'Monto inválido': 'Invalid amount',
  'Registrar': 'Record',
  'Saldo: {amount}': 'Balance: {amount}',
  'Monto': 'Amount',
  'Método': 'Method',
  'Efectivo': 'Cash',
  'Cheque': 'Check',
  'Tarjeta (terminal)': 'Card (terminal)',
  'Otro': 'Other',
} satisfies Record<string, string>;
